import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Highlight from "@tiptap/extension-highlight";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Image from "@tiptap/extension-image";
import YouTube from "@tiptap/extension-youtube";
import TextStyle from "@tiptap/extension-text-style";
import FontFamily from "@tiptap/extension-font-family";
import { Color } from "@tiptap/extension-color";
import Bold from "@tiptap/extension-bold";
import DatePicker from "react-datepicker";
import Button from "../../layout/button";
import "react-datepicker/dist/react-datepicker.css";
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle,
} from "@headlessui/react";
import { Auth } from "aws-amplify";

import { sendSurveyFromAPI, updateSurveyFromAPI, getSurveyDetailFromAPI } from "../../../services/surveyService";
import { updateTabStates } from "../../../store/actions";

export default function CollectSchedule() {

    const themeMode = useSelector(state => state.themeMode);
    // const currentSurvey = useSelector(state => state.currentSurvey);
    // const surveyRecipients = useSelector(state => state.surveyRecipients);
    const topMenuTabs = useSelector((state) => state.topMenuTabs);

    // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
    const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;
    const surveyRecipients = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.surveyRecipients;

    const dispatch = useDispatch();

    let [token, setToken] = useState("");
    const [emailSubject, setEmailSubject] = useState("");
    const [emailMessage, setEmailMessage] = useState("");
    const [respCheckSurvey, setRespCheckSurvey] = useState("");
    const [sendInfoMenuShow, setSendInfoMenuShow] = useState(false)
    const [sendMailErrorShow, setSendMailErrorShow] = useState(false)
    async function checkAuth() {
        // window.location.reload();
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            const currentSession = await Auth.currentSession();
            await cognitoUser.refreshSession(
                currentSession.refreshToken,
                (err, session) => {
                    const { idToken, refreshToken, accessToken } = session;
                    getToken(idToken.jwtToken);
                }
            );
        } catch (e) {
            // console.log('Unable to refresh Token', e);
        }
    }

    useEffect(() => {
        getToken();
    }, []);

    async function getToken(token) {
        if (token) {
            setToken(token);
        } else {
            const currentSession = await Auth.currentSession();
            setToken(currentSession.idToken.jwtToken);
        }
    }

    useEffect(() => {
        setEmailSubject(currentSurvey?.email_template?.subject);
        setEmailMessage(currentSurvey?.email_template?.message);
        setEmails(currentSurvey?.survey_users?.map((user) => user.email));
    }, [currentSurvey]);

    useEffect(() => {
        // Custom Extensions for Font Size and Bold Mark
        const FontSizeTextStyle = TextStyle.extend({
            addAttributes() {
                return {
                    fontSize: {
                        default: null,
                        parseHTML: (element) => element.style.fontSize,
                        renderHTML: (attributes) => {
                            if (!attributes.fontSize) {
                                return {};
                            }
                            return { style: "font-size: " + attributes.fontSize };
                        },
                    },
                };
            },
        });

        const CustomBold = Bold.extend({
            renderHTML({ mark, HTMLAttributes }) {
                const { style, ...rest } = HTMLAttributes;
                const newStyle = "font-weight: bold;" + (style ? " " + style : "");
                return ["span", { ...rest, style: newStyle.trim() }, 0];
            },
            addOptions() {
                return {
                    ...this.parent?.(),
                    HTMLAttributes: {},
                };
            },
        });

        // Initialize the editor
        const editor = new Editor({
            element: document.querySelector("#wysiwyg-editor"),
            extensions: [
                StarterKit.configure({
                    marks: {
                        bold: false,
                    },
                }),
                CustomBold,
                TextStyle,
                Color,
                FontSizeTextStyle,
                FontFamily,
                Highlight,
                Underline,
                Link.configure({
                    openOnClick: false,
                    autolink: true,
                    defaultProtocol: "https",
                }),
                TextAlign.configure({
                    types: ["heading", "paragraph"],
                }),
                HorizontalRule,
                Image,
                YouTube,
            ],
            content: emailMessage.length > 0 ? emailMessage : previewMail(currentSurvey?.email_template?.message),
            editable: false,
            editorProps: {
                attributes: {
                    class:
                        "format lg:format-lg dark:format-invert focus:outline-none format-blue max-w-none",
                },
            },
        });

        // Set up event listeners for toolbar buttons (optional)
        const toggleBoldButton = document.getElementById("toggleBoldButton");
        const toggleItalicButton = document.getElementById("toggleItalicButton");
        const toggleUnderlineButton = document.getElementById(
            "toggleUnderlineButton"
        );
        const toggleLinkButton = document.getElementById("toggleLinkButton");
        const toggleAlignButtons = [
            document.getElementById("toggleLeftAlignButton"),
            document.getElementById("toggleCenterAlignButton"),
            document.getElementById("toggleRightAlignButton"),
        ];

        toggleBoldButton?.addEventListener("click", () =>
            editor.chain().focus().toggleBold().run()
        );
        toggleItalicButton?.addEventListener("click", () =>
            editor.chain().focus().toggleItalic().run()
        );
        toggleUnderlineButton?.addEventListener("click", () =>
            editor.chain().focus().toggleUnderline().run()
        );

        toggleLinkButton?.addEventListener("click", () => {
            const url = window.prompt("Enter image URL:", "https://flowbite.com");
            editor.chain().focus().toggleLink({ href: url }).run();
        });

        toggleAlignButtons.forEach((button) => {
            button?.addEventListener("click", () => {
                const align = button.id.replace("toggle", "").toLowerCase();
                editor.chain().focus().setTextAlign(align).run();
            });
        });

        return () => {
            // Cleanup on component unmount
            editor.destroy();
        };
    }, []);
    const [isChecked, setIsChecked] = useState(false); // Checkbox durumunu kontrol etmek için
    const [scheduleDate, setScheduleDate] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState("");
    const [selectedOption, setSelectedOption] = useState("now");
    const handleCheckboxChange = (e, option) => {
        setIsChecked(e.target.checked);
        setSelectedOption(option);
    };
    const [emails, setEmails] = useState([]);

    useEffect(() => {
        if (currentSurvey) {
            setEndDate(currentSurvey.end_date ? new Date(currentSurvey.end_date) : "");
        }
    }, [currentSurvey]);

    async function sendSurvey() {
        const toList = currentSurvey?.survey_users.filter(item => !surveyRecipients.map((item) => item.user_id).includes(item.user_id));
        console.log('toList:', toList);
        if (toList.length > 0) {
            await sendSurveyFromAPI(token, { survey_id: currentSurvey.ID, users: toList }).then((result) => {
                viewSurveyProgress();
                setSendInfoMenuShow(true);
            }).catch((error) => {
            }).finally(() => {
                dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
            });
        } else {
            dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
        }
    }

    async function scheduleSendSurvey(scheduleDt) {
        const toList = currentSurvey?.survey_users.filter(item => !surveyRecipients.map((item) => item.user_id).includes(item.user_id));
        if (toList.length > 0) {
            await sendSurveyFromAPI(token, { survey_id: currentSurvey.ID, users: toList, schedule_date: scheduleDt }).then((result) => {
                viewSurveyProgress();
                setSendInfoMenuShow(true)
            }).catch((error) => {
            }).finally(() => {
                dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
            });
        } else {
            dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
        }
    }

    const checkSurvey = () => {
        // ankette section yoksa
        if (currentSurvey.content.pages.filter(p => p.name !== 'intro').length === 0) {
            setRespCheckSurvey('Survey must have at least one section');
            return 'Survey must have at least one section';
        }
        // if (currentSurvey.content.pages.filter(p => p.type === 'demographics').length == 0) {
        //     return 'demographics';
        // }
        // ankette section altında hiç page yoksa
        for (const section of currentSurvey.content.pages.filter(p => p.name !== 'intro')) {
            if (section.elements[0].elements.filter(e => e.type === 'html').length === 0) {
                setRespCheckSurvey('Sections must have at least one page');
                return 'Sections must have at least one page';
            }
            if (section.elements[0].elements[section.elements[0].elements.length - 1].type === 'html') {
                setRespCheckSurvey('Pages must have at least one question');
                return 'Pages must have at least one question';
            }
            for (const el of section.elements[0].elements.filter(e => e.type !== 'html')) {
                if (el.elements[0].title === '') {
                    setRespCheckSurvey('Questions must have a title');
                    return 'Questions must have a title';
                }
                if (el.elements[0].type === 'radiogroup' || el.elements[0].type === 'checkbox'
                    || el.elements[0].type === 'dropdown' || el.elements[0].type === 'tagbox' || el.elements[0].type === 'ranking') {
                    if (el.elements[0].choices.length === 0) {
                        setRespCheckSurvey("Question of '" + el.elements[0].title + "' must have at least one option");
                        return "Question of '" + el.elements[0].title + "' must have at least one option";
                    }
                }
            };
        };
        if (currentSurvey.email_template.subject === '') {
            setRespCheckSurvey('Subject is required');
            return 'Subject is required';
        }
        if (!currentSurvey.email_template.message.includes('[Survey Url]')
            || !currentSurvey.email_template.message.includes('[Survey Name]')
            || !currentSurvey.email_template.message.includes('[First Name]')
            || !currentSurvey.email_template.message.includes('[Last Name]')
            || !currentSurvey.email_template.message.includes('[Organization Name]')) {
            setRespCheckSurvey('Message must include [Survey Url], [Survey Name], [First Name], [Last Name], [Organization Name]');
            return 'Message must include [Survey Url], [Survey Name], [First Name], [Last Name], [Organization Name]';
        }

        setRespCheckSurvey('');
        return '';
    };

    async function updateSurveyEndDate() {
        try {
            const obj = {
                end_date: endDate !== "" ? endDate.toISOString() : ""
            };
            const _currentSurvey = { ...currentSurvey };
            _currentSurvey.end_date = endDate !== "" ? endDate.toISOString() : "";

            await updateSurveyFromAPI(token, obj, _currentSurvey.ID)
                .then((result) => {
                    console.log("update survey result : ", result);
                    dispatch(updateTabStates(topMenuTabs.activeTab, "currentSurvey", _currentSurvey));
                })
                .catch((error) => {
                    console.log("update survey error : ", error);
                });
        } catch (error) {
            console.log("update survey error : ", error);
        }
    }

    async function handleSend() {
        dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
        if ((currentSurvey?.end_date === undefined && endDate !== "") || (currentSurvey?.end_date !== endDate.toString())) {
            await updateSurveyEndDate();
        }
        const resp = checkSurvey();
        if (resp.length > 0) {
            if (resp === 'demographics') {

            } else {
                setSendMailErrorShow(true)
                dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
            }
        }
        else if (startDate <= new Date()) {
            sendSurvey()
        } else {
            scheduleSendSurvey(startDate);
        }
    };

    const previewMail = (message) => {
        if (currentSurvey?.survey_users?.length > 0) {
            message = message.replaceAll("[Survey Name]", currentSurvey.survey_name);
            message = message.replaceAll("[First Name]", currentSurvey.survey_users[0].first_name);
            message = message.replaceAll("[Last Name]", currentSurvey.survey_users[0].last_name);
            message = message.replaceAll("[Organization Name]", currentSurvey.organization);
        }

        return message;
    }

    async function viewSurveyProgress() {
        await getSurveyDetailFromAPI(token, currentSurvey.ID)
            .then((result) => {
                console.log("get survey detail result : ", result);
                // dispatch(setSurveyRecipients(result["userSurveyItems"]));
                dispatch(updateTabStates(topMenuTabs.activeTab, 'surveyRecipients', result["userSurveyItems"]));
                dispatch(updateTabStates(topMenuTabs.activeTab, 'currentSurvey', result["surveyItem"]));
            })
            .catch((error) => {
                console.log("get survey detail error : ", error);
            });
    }
  useEffect(() => {
    // Automatically close the dialog after 5 seconds
    const timer = setTimeout(() => {
      setSendInfoMenuShow(false);
    }, 3000); // 5000 ms = 5 seconds

    // Cleanup the timer when the component unmounts or dialog closes
    return () => clearTimeout(timer);
  }, [sendInfoMenuShow]);
    return (
        <div
            className={` flex h-full w-full flex-col space-y-4 ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#fbfbfc]"
                } `}
        >
            <div className="flex justify-start px-12 flex-col space-y-2 sm:flex-row sm:space-y-0 w-full xl:w-1/2 pt-4">
                <span
                    className={`w-1/6 font-bold py-1  leading-4 text-base whitespace-nowrap break-all  min-w-0  ${themeMode === "dark" ? "text-[#c1c9d6]" : "text-[#5a667e]"
                        }`}
                >
                    To:
                </span>
                <div
                    className={`rounded-[0.375rem] px-3  py-1.5 border w-5/6  ${themeMode === "dark"
                        ? "bg-[#1C1C29] border-[1px] border-solid border-[rgba(255,255,255,0.09)]"
                        : "border-[1px] border-solid  bg-[#F4F4F6]"
                        }  `}
                >
                    <div className="flex flex-wrap py-1 gap-2">
                        <div className="flex flex-wrap py-1 gap-2">
                            {emails?.slice(0, 10)?.map((user, index) => (
                                <div key={index} className="flex">
                                    <div
                                        className={`px-2 cursor-pointer h-6 w-auto rounded-lg text-xs text-white bg-[#46A44F] border border-[#46A44F0f] border-opacity-10 flex items-center justify-center`}
                                    >
                                        {user}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-start px-12 flex-col space-y-2 sm:flex-row sm:space-y-0 w-full xl:w-1/2">
                <span
                    className={`w-1/6 font-bold py-1  leading-4 text-base whitespace-nowrap break-all  min-w-0  ${themeMode === "dark" ? "text-[#c1c9d6]" : "text-[#5a667e]"
                        }`}
                >
                    Subject:
                </span>
                <div
                    className={`rounded-[0.375rem] px-3  py-1.5 border w-5/6  ${themeMode === "dark"
                        ? "bg-[#1C1C29] border-[1px] border-solid border-[rgba(255,255,255,0.09)]"
                        : "border-[1px] border-solid  bg-[#F4F4F6]"
                        }  `}
                >
                    <input
                        id="name"
                        name="name"
                        type="text"
                        value={emailSubject}
                        disabled
                        className={`block w-full sm:text-sm/6 ${themeMode === "dark"
                            ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                            : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                            }`}
                    />
                </div>
            </div>
            <div className="flex justify-start px-12 flex-col space-y-2 sm:flex-row sm:space-y-0 w-full xl:w-1/2">
                <span
                    className={`w-1/6 font-bold py-1  leading-4 text-base whitespace-nowrap break-all  min-w-0  ${themeMode === "dark" ? "text-[#c1c9d6]" : "text-[#5a667e]"
                        }`}
                >
                    Message:
                </span>

                <div
                    className={` rounded-[0.375rem] block  w-5/6   sm:text-sm/6 ${themeMode === "dark" ? "bg-[#1C1C29] " : "bg-[#F4F4F6]"}`}
                >
                    <div
                        className={`px-4 py-2 rounded-b-lg  h-[300px]  overflow-y-auto ${themeMode === "dark"
                            ? "bg-[#1C1C29] border-[1px] border-solid border-white-09"
                            : "border-[1px] border-solid  bg-[#F4F4F6]"
                            }  `}
                    >
                        <div
                            id="wysiwyg-editor"
                            className={`edtior-container  ${themeMode === "dark"
                                ? "text-white placeholder-gray-400"
                                : "text-gray-800"
                                }`}
                        ></div>
                        <label for="wysiwyg-example" className="sr-only">
                            Publish post
                        </label>
                        <div
                            id="wysiwyg-example"
                            className="block w-full px-0 text-sm text-gray-800 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400"
                        ></div>
                    </div>
                </div>
            </div>
            <div className="flex justify-start cursor-pointer px-12 ">

                <div className="bg-transparent py-2 rounded-md">
                    <label
                        htmlFor="start-date-picker"
                        className={`w-1/6 font-bold py-1 block mb-1 leading-4 text-base whitespace-nowrap break-all  min-w-0  ${themeMode === "dark" ? "text-[#c1c9d6]" : "text-[#5a667e]"
                            }`}
                    >
                        Start Date:
                    </label>
                    <DatePicker
                        id="start-date-picker"
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="MMMM d, yyyy h:mm aa"
                        className="p-2 border border-white-09 rounded-md max-w-72 bg-transparent text-white"
                    />
                </div>

                <div className="bg-transparent py-2 rounded-md ml-2">
                    <label
                        htmlFor="start-date-picker"
                        className={`w-1/6 font-bold py-1 block mb-1 leading-4 text-base whitespace-nowrap break-all  min-w-0  ${themeMode === "dark" ? "text-[#c1c9d6]" : "text-[#5a667e]"
                            }`}
                    >
                        End Date:
                    </label>
                    <DatePicker
                        id="start-date-picker"
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeIntervals={15}
                        dateFormat="MMMM d, yyyy h:mm aa"
                        minDate={new Date()}
                        minTime={endDate && endDate.toDateString() === new Date().toDateString() ? new Date() : new Date(0, 0, 0, 0, 0)}
                        maxTime={new Date(0, 0, 0, 23, 45)}
                        className="p-2 border border-white-09 rounded-md max-w-72 bg-transparent text-white"
                        autoComplete="off"
                    />
                </div>
            </div>
            <div className="flex justify-start cursor-pointer px-12 ">
            <Button text="Save & Send" onClick={()=> handleSend()} disabled={false}  themeMode={themeMode}  className="flex-shrink-0 px-3 py-0 h-[1.5rem] lg:h-8   rounded-lg transition duration-150 min-w-[1.375rem] whitespace-nowrap text-[0.8125rem] flex items-center" type="submit"/>

             
            </div>
            <Dialog
                open={sendInfoMenuShow}
                onClose={setSendInfoMenuShow}
                className="relative z-10"
            >
              <DialogBackdrop
                       transition
                       className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                     />
             
                     <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
                       <div className="flex min-h-full w-1/6 items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
                         <DialogPanel
                           transition
                           className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${
                             themeMode === "dark"
                               ? "bg-[#2a2939] border-white-09"
                               : "bg-[#FFFFFF] border-black-09 "
                           } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
                         >
                            <div>
                                <div className="mt-0 text-start sm:mt-0">
                                    <DialogTitle
                                        as="h3"
                                        className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                                            }`}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            className="size-6"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                fill="#008000"
                                                stroke="#fff"
                                            />
                                        </svg>
                                        Mail sent
                                    </DialogTitle>
                                </div>
                            </div>
                            <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                                <button
                                    type="button"
                                    onClick={() => setSendInfoMenuShow(false)}
                                    className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                                        ? " border-white-09  "
                                        : " border-black-09 "
                                        } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                                >
                                    Ok
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>

            <Dialog
                open={sendMailErrorShow}
                onClose={setSendMailErrorShow}
                className="relative z-10"
            >
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-black opacity-50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-4 pb-0">
                    <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                        <DialogPanel
                            transition
                            className={`relative transform rounded-lg shadow-lg border border-solid ${themeMode === "dark"
                                ? "bg-[#2a2939] border-white-09"
                                : "bg-[#FFFFFF] border-black-09"
                                } overflow-hidden px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6`}
                        >
                            <div className="flex items-center">
                                <div className="flex-shrink-0">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="w-12 h-12 text-red-600"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                    </svg>
                                </div>
                                <div className="ml-4">
                                    <DialogTitle
                                        as="h3"
                                        className={`text-lg leading-6 font-medium ${themeMode === "dark" ? "text-white" : "text-gray-900"}`}
                                    >
                                        Error
                                    </DialogTitle>
                                    <div className={`mt-2 ${themeMode === "dark" ? "text-gray-300" : "text-gray-600"}`}>
                                        <p>{respCheckSurvey}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    onClick={() => setSendMailErrorShow(false)}
                                    className={`inline-flex w-full justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm`}
                                >
                                    Ok
                                </button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
            {/* </div> */}
            {/* Drawer */}
        </div>
    );
}